/* global angular */
import './style.less';
import { orderBy } from 'lodash';

export default function(
  $q,
  $state,
  $stateParams,
  $filter,
  $log,
  Swal,
  Upload,
  ApiClass,
  ProfileClass,
  RegulatorClass,
  ResolveClass
) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const reg_id = $stateParams.reg_id;
  const profile_uid = $stateParams.employeeID || $stateParams.id;
  const manage = ResolveClass.isManageRoute();

  vm.removeFile = index => {
    vm.profile.misc_urls.licenses[reg_id].splice(index, 1);
    return ApiClass.usersIdPatch({ id: profile_uid }, { misc_urls: vm.profile.misc_urls })
      .then(() => activate())
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.uploadFile = file => {
    function uploadFile({ data: { item: s3Policy } }) {
      return Upload.upload({
        url: s3Policy.filePolicy.action,
        data: s3Policy.filePolicy.fields,
        file: file,
        method: 'POST',
        skipAuthorization: true
      }).then(
        () => {
          return {
            name: file.name,
            url: s3Policy.link,
            date: new Date().toISOString()
          };
        },
        resp => {
          vm.uploadBtn = false;
          $log.error('Error status: ' + resp.status);
          throw new Error(`PDF UPLOADING ERROR ${$stateParams.id}`);
        },
        evt => {
          const pdfStaus = parseInt((100.0 * evt.loaded) / evt.total);
          vm.pdfProgress = `${pdfStaus}%`;
        }
      );
    }

    function updateProfile(item) {
      const misc_urls = Object.assign({}, vm.profile.misc_urls || {});
      if (!misc_urls.licenses) misc_urls.licenses = {};
      if (!misc_urls.licenses[reg_id]) misc_urls.licenses[reg_id] = [];
      misc_urls.licenses[reg_id].push(item);
      return ApiClass.usersIdPatch({ id: profile_uid }, { misc_urls });
    }

    if (!file) return;
    vm.uploadBtn = true;
    ApiClass.companiesIdTypePut(
      { manage, id: ProfileClass.company_id, type: 'policies' },
      {
        profile_uid,
        reg_id,
        policy: 'license',
        file_type: file.type,
        file_name: file.name
      }
    )
      .then(uploadFile)
      .then(updateProfile)
      .then(() => {
        activate();
        vm.uploadBtn = false;
        delete vm.fileToUpload;
      })
      .catch(error => {
        vm.uploadBtn = false;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    vm.formData = {};
    vm.extensionFormData = {};

    const qArr = [
      RegulatorClass.loadRegulators(),
      ApiClass.usersIdGet(
        { id: profile_uid, manage: false },
        {},
        {
          queryParams: {
            'include:compliance': true
          }
        }
      )
    ];

    $q.all(qArr)
      .then(([{ obj: regulatorDict }, { data: { item: profile, compliance } }]) => {
        const licenses = compliance.filter(license => license.reg_id === reg_id);

        const years = orderBy(licenses, ['expiration_date', 'annual_date'], ['desc', 'desc']);
        const license = years[0];

        // check if attestation version of license exists
        vm.regulator = regulatorDict[license.reg_id][license.reg_date];

        vm.attestation = vm.regulator.join && vm.regulator.join.versions && vm.regulator.join.versions.attestation;
        vm.custom = vm.regulator.join && vm.regulator.join.versions && vm.regulator.join.versions.custom;
        const extension = vm.regulator.cycle_limiter.extension ? vm.regulator.cycle_limiter.extension : false;
        vm.extension = angular.copy(extension);
        vm.profile = profile;

        if (vm.extension) {
          vm.cycles = years.reduce((byCycle, cycle) => {
            const cycleYear = $filter('date')(cycle.cycle_date, 'yyyy');
            cycle.annual_year = `${$filter('date')($filter('RangeDate')(cycle.annual_date, 1), 'MMM d, y')} - ${$filter(
              'date'
            )(cycle.annual_date, 'MMM d, y')}`;
            cycle.hasExtension = !!cycle.extension_date;
            cycle.extension = angular.copy(extension);
            cycle.extension_date = isNaN(new Date(cycle.extension_date).getTime())
              ? new Date()
              : new Date(cycle.extension_date);
            if (!byCycle[cycleYear] || cycle.annual_date > byCycle[cycle.lic_yr].annual_date)
              byCycle[cycle.lic_yr] = cycle;
            return byCycle;
          }, {});
        }

        vm.resultsQueried = true;
        vm.formData = license;
        vm.formData.cycle_date = new Date(license.cycle_date);
        vm.formData.issue_date = new Date(license.issue_date);
        vm.formData.expiration_date = new Date(license.expiration_date);

        if (vm.attestation) vm.formData.attestation = reg_id === vm.regulator.join.versions.attestation;
        if (vm.custom) vm.formData.custom = reg_id === vm.regulator.join.versions.custom;
        if ('active' in vm.formData === false || license.active === undefined || license.active === null)
          vm.formData.active = true;

        let licenseType = $filter('Capitalize')(vm.regulator.license, 'license');

        if (reg_id.indexOf('firm') > -1) licenseType = 'Firm Requirement';
        if (reg_id.indexOf('at') > -1) licenseType += ' Attestation';

        vm.viewFormData = {
          license: licenseType,
          state: vm.regulator.basic_name
        };
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/licenses/license/attachments/index.js